import QRCode from 'qrcode.react';
import InputMask from 'react-input-mask';
import { useState } from 'react';

import Button from 'Components/UI_Library/FormElements/Button';
import classes from '../MFA.module.css';
import inputClasses from 'Components/UI_Library/FormElements/Inputs.module.css';
import InputError from 'Components/UI_Library/FormElements/InputError';

const TOTPMFA = ({
    exitForm,
    copyToClipboard,
    toggleTextCode,
    handleVerifyTOTPCode,
    setTOTPCode,
    TOTPCode,
    QRToken,
    isQrUrl,
    isQrCodeLoading,
    loadingAuthApp,
    codeAsText,
    copyButtonText,
    errors,
}: {
    exitForm: () => void;
    copyToClipboard?: () => void;
    toggleTextCode?: () => void;
    handleVerifyTOTPCode: () => void;
    setTOTPCode: (code: string) => void;
    TOTPCode?: string;
    QRToken?: string;
    isQrUrl?: boolean;
    isQrCodeLoading?: boolean;
    loadingAuthApp: boolean;
    codeAsText?: boolean;
    copyButtonText?: string;
    errors: { code?: string; TOTPCode?: string };
}) => {
    const [hasImageLoaded, setHasImageLoaded] = useState(false);

    const renderQrCode = () => (
        <>
            {isQrUrl && (isQrCodeLoading || !hasImageLoaded) && (
                <div className={`${classes.skeleton} ${classes.qrCodePlaceholder}`} />
            )}
            {isQrUrl && !isQrCodeLoading && <img alt="QR Code" src={QRToken} onLoad={() => setHasImageLoaded(true)} />}
            {!isQrUrl && <QRCode value={QRToken || ''} />}
        </>
    );

    return (
        <div className={classes.authAppForm}>
            <div className={classes.formHeading}>
                <h5>Follow the steps below</h5>
                <Button type="link-cancel" onClick={() => exitForm()} text="Cancel" />
            </div>
            <div className={classes.enableAuthApp}>
                <div className={`${classes.step} ${isQrUrl ? classes.stepQrUrl : ''}`}>
                    {codeAsText ? (
                        <>
                            <p>Copy the text code to your clipboard by clicking on the button below</p>

                            <Button type="white-condensed" onClick={() => copyToClipboard?.()} text={copyButtonText} />
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Button type="ghost" onClick={() => toggleTextCode?.()} text="Go back" />
                                to the QR code.
                            </div>
                        </>
                    ) : (
                        <>
                            <p>Scan the QR code below with your app.</p>
                            {renderQrCode()}
                            {!isQrUrl && (
                                <Button
                                    type="white-condensed"
                                    text="Receive text code instead"
                                    onClick={() => toggleTextCode?.()}
                                />
                            )}
                        </>
                    )}
                </div>
                <div className={errors.TOTPCode ? `${classes.step} ${classes.error}` : classes.step}>
                    <p>Enter the 6 digit code from the app:</p>
                    <InputMask
                        name="TOTPCode"
                        placeholder="------"
                        value={TOTPCode || ''}
                        className={inputClasses.generalTextInput}
                        style={{ textAlign: 'center' }}
                        mask="999999"
                        maskChar={null}
                        onChange={(e) => setTOTPCode(e.target.value)}
                    />
                    <InputError error={errors.TOTPCode} />
                    <Button
                        type="primary"
                        onClick={() => handleVerifyTOTPCode()}
                        loading={loadingAuthApp}
                        disabled={loadingAuthApp}
                        text="Verify"
                    />
                </div>
            </div>
            <div className={classes.noApp}>
                Don&apos;t have an authentication app already? We recommend
                <a href="https://authy.com/download/" target="_blank" rel="noopener noreferrer">
                    Authy
                </a>
                .
            </div>
        </div>
    );
};

export default TOTPMFA;
